export default {
  integrationSources: [
    // Etsy removed Jan 2026 - FRE-1565
    {
      name: 'Stripe' /* Name of integration source */,
      enabled: true /* Enabled/Disabled */,
      description:
        'Connect your Stripe account to help you track additional sources of revenue outside of FreshBooks.' /* Description / copy */,
      requiresSelection: false /* Boolean indicating if source requires selection */,
      settings: null,
    },
    {
      name: 'Square' /* Name of integration source */,
      enabled: true /* Enabled/Disabled */,
      description:
        'Connect your Square account to help you track additional sources of revenue outside of FreshBooks' /* Description / copy */,
      requiresSelection: false /* Boolean indicating if source requires selection */,
      settings: null,
    },
  ],
};
